import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useFunctionPersonal = () => {
  const initialData = { item: Mappers.FunctionPersonal() };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'function-personal'],
    async () => {
      const { data } = await Api.FunctionalPersonal();

      return {
        item: Mappers.FunctionPersonal(data && data.data)
      };
    },
    { initialData }
  );

  return { ...args, ...data };
};

export default useFunctionPersonal;
